import * as ReactQuery from 'react-query';
import { getReferralHistoryAPI } from './api';

export const GET_REFERRAL_HISTORY_KEY =
  '@referrals/get-referral-history-activity';

type UseGetReferralHistoryOptions = {
  enabled?: boolean;
  isExternalReferral?: boolean;
};

export function useGetReferralHistory(
  id = '',
  {
    enabled = true,
    isExternalReferral = false,
  }: UseGetReferralHistoryOptions = {}
) {
  const { data, isFetching, isError, refetch } = ReactQuery.useQuery(
    [GET_REFERRAL_HISTORY_KEY, id, isExternalReferral],
    () => getReferralHistoryAPI(id, isExternalReferral),
    { enabled: enabled && Boolean(id) }
  );

  return {
    history: data,
    isFetching,
    isError,
    refetch,
  };
}
